export default __webpack_public_path__ + "static/media/goopter-hardware-hotel-use-case.8084e6ff.jpg";